import { getDefaultClient, IRequestOptions } from '@ifit/gateway-core';

export async function achievementServiceIsDown({ client = getDefaultClient() }: IRequestOptions): Promise<boolean> {
  if (!client) {
    throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
  }

  return client.isDown('achievement-service');
}
